import { useEffect, useCallback } from "react";

export const useNetworkStatusChange = (onLine = null, offLine = null) => {
  const handleOnline = useCallback(() => {
    if (typeof onLine === `function`) onLine();
  }, [onLine]);

  const handleOffline = useCallback(() => {
    if (typeof offLine === `function`) offLine();
  }, [offLine]);

  useEffect(() => {
    window.addEventListener(`online`, handleOnline);
    window.addEventListener(`offline`, handleOffline);

    return () => {
      window.removeEventListener(`online`, handleOnline);
      window.removeEventListener(`offline`, handleOffline);
    };
  }, [handleOnline, handleOffline]);
};
